module.exports = __webpack_public_path__ + "img/apple.96b6de01.png";